import { useState } from 'react';
import { Option } from '../../types/common/table';
import { INITIAL_OPTION } from '../../constants/service/common/tableConstants';

export const useTableOption = <Filter extends Record<string, unknown>>(initialOption?: Option<Filter>) => {
  const completeInitialOption = initialOption
    ? {
        pagination: initialOption.pagination || INITIAL_OPTION.pagination,
        sortOption: initialOption.sortOption || INITIAL_OPTION.sortOption,
        filterOption: initialOption.filterOption || INITIAL_OPTION.filterOption,
      }
    : INITIAL_OPTION;

  const [pagination, setPaginationOption] = useState(completeInitialOption.pagination);
  const [sortOption, setSortOption] = useState(completeInitialOption.sortOption);
  const [filterOption, setFilterOption] = useState<Filter>(completeInitialOption.filterOption);

  const changeOption = ({ pagination, filterOption: filter, sortOption: sort }: Option<Filter>) => {
    if (pagination) {
      setPaginationOption({ pageNum: pagination.pageNum, pageSize: pagination.pageSize });
    }

    if (filter) {
      setFilterOption({ ...filter });
    }

    if (sort) {
      setSortOption(sort);
    }
  };

  const resetOption = () => changeOption(completeInitialOption);

  return { pagination, sortOption, filterOption, changeOption, resetOption };
};
